module.exports = __webpack_public_path__ + "img/ic_sharp-file-upload.1ce3357a.svg";